import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { FormControl, InputLabel, MenuItem, Select, Skeleton, Stack, TextField } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";

import CrudService from "services/cruds-service";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import MDNumberFormatInput from "components/MDNumberFormatInput";

const EditSubscriptionPlan = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        plan_name: "",
        billing_cycle: null,
        description: "",
        price_per_device: "",
    });
    const [loader, setLoader] = useState(true)

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (id) {
                    const response = await CrudService.getSubscriptionPlanListById(id);
                    if (response.success) {
                        let data = response.data
                        setFormData({
                            plan_name: data.plan_name,
                            description: data.description,
                            billing_cycle: data.billing_cycle,
                            price_per_device: data.price_per_device
                        });
                        setLoader(false)
                    } else {
                        toast.error('Error when recieved data')
                    }
                }
            } catch (err) {
                console.error(err);
                toast.error(err.error)
            }
        };

        fetchData();
    }, [id]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        const templates = {
            ...formData,
        }

        try {
            await CrudService.updateSubscriptionPlan(id, templates);
            navigate("/subscription-plan", {
                state: { value: true, text: "The subscription plan was successfully updated" },
            });
            toast.success("The subscription plan was successfully updated")
        } catch (err) {
            console.error(err);
            toast.error(err.error)
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox mt={5} mb={9}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={8}>
                        <MDBox mt={6} mb={8} textAlign="center">
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    Edit Subscription Plan
                                </MDTypography>
                            </MDBox>
                        </MDBox>
                        <Card>
                            <MDBox component="form" onSubmit={submitHandler} >
                                {
                                    !loader ?
                                        <MDBox display="flex" flexDirection="column" px={3} my={2}>

                                            <TextField fullWidth label="Plan Name" name="plan_name" value={formData.plan_name} onChange={handleChange} margin="normal" required />
                                            <TextField fullWidth label="Description" name="description" value={formData.description} onChange={handleChange} margin="normal" />
                                            <FormControl sx={{ mt: 1 }} required>
                                                <InputLabel id="billing_cycle-label">Billing Cycle</InputLabel>
                                                <Select
                                                    labelId="billing_cycle-label"
                                                    id="billing_cycle"
                                                    name="billing_cycle"
                                                    value={formData.billing_cycle ?? ''}
                                                    label="Billing Cycle" // This must match InputLabel text
                                                    onChange={handleChange}
                                                    sx={{
                                                        '& .MuiSelect-select': {
                                                            minHeight: '3em !important',
                                                        },
                                                    }}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    <MenuItem value="monthly">Monthly</MenuItem>
                                                    <MenuItem value="yearly">Yearly</MenuItem>
                                                </Select>
                                            </FormControl>

                                            <MDNumberFormatInput fullWidth label="Price Per Device" name="price_per_device" value={formData.price_per_device} onChange={handleChange} margin="normal" required />
                                            <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
                                                <MDBox mx={2}>
                                                    <MDButton
                                                        variant="gradient"
                                                        color="dark"
                                                        size="small"
                                                        px={2}
                                                        mx={2}
                                                        onClick={() =>
                                                            navigate("/subscription-plan", {
                                                                state: { value: false, text: "" },
                                                            })
                                                        }
                                                    >
                                                        Back
                                                    </MDButton>
                                                </MDBox>
                                                <MDButton variant="gradient" color="dark" size="small" type="submit" >
                                                    Update
                                                </MDButton>
                                            </MDBox>
                                        </MDBox> :
                                        <Stack spacing={1} px={3} my={2}>
                                            <Skeleton variant="rectangular" sx={{ fontSize: "4rem" }} />
                                            <Skeleton variant="rectangular" sx={{ fontSize: "4rem" }} />
                                            <Skeleton variant="rectangular" sx={{ fontSize: "4rem" }} />
                                            <Skeleton variant="rectangular" sx={{ fontSize: "4rem" }} />
                                        </Stack>
                                }
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
};

export default EditSubscriptionPlan;
